var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 74,
    viewBox: "0 0 56 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "A\xC5\x9Fa\xC4\x9F\xC4\xB1ya"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4192",
    d: "M1 58V28C1 13.0883 13.0883 1 28 1C42.9117 1 55 13.0883 55 28V58",
    stroke: "#84C1FF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4191",
    x: 8,
    y: 12,
    width: 40,
    height: 62,
    rx: 19,
    fill: "#007FFF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 27C27.7054 27 27.4228 27.1129 27.2144 27.3138C27.0061 27.5147 26.889 27.7872 26.889 28.0714L26.889 53.3405L19.8989 46.5973C19.6903 46.3961 19.4074 46.2831 19.1124 46.2831C18.8173 46.2831 18.5344 46.3961 18.3258 46.5973C18.1172 46.7985 18 47.0713 18 47.3558C18 47.6403 18.1172 47.9132 18.3258 48.1144L27.2134 56.6852C27.3166 56.785 27.4392 56.8642 27.5742 56.9182C27.7092 56.9722 27.8539 57 28 57C28.1461 57 28.2908 56.9722 28.4258 56.9182C28.5608 56.8642 28.6834 56.785 28.7866 56.6852L37.6742 48.1144C37.7775 48.0148 37.8594 47.8965 37.9153 47.7664C37.9712 47.6362 38 47.4967 38 47.3558C38 47.0713 37.8828 46.7985 37.6742 46.5973C37.4656 46.3961 37.1827 46.2831 36.8876 46.2831C36.5926 46.2831 36.3097 46.3961 36.1011 46.5973L29.111 53.3405L29.111 28.0714C29.111 27.7872 28.9939 27.5147 28.7856 27.3138C28.5772 27.1129 28.2946 27 28 27Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainDown);
export default __webpack_public_path__ + "static/media/MainDown.ffb20e976217032b1f36c6568c306215.svg";
export { ForwardRef as ReactComponent };